import { DEFAULT_USER, INTEGRATION_DOCUMENT } from '~/consts/psf';
import apiPSFAnon from '~/services/apiPSFAnon';
import type { UserType } from '~/stores/userInfo';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

export async function journeyLogUseCase(
  user: UserType | null,
  type:
    | 'AUTO'
    | 'CONSORCIO'
    | 'MARISACUIDA'
    | 'PROTECAOBOLSA'
    | 'ASSIST_DESEMPREGO'
    | 'ODONTO'
    | 'PERDARENDA' = 'AUTO'
) {
  try {
    if (user) {
      const [origin, originId] = MarisaAppUtils.getOriginTypeInfos();

      apiPSFAnon.post(`digital/api/messages/inclusaoLogJornada`, {
        loginUsuario: DEFAULT_USER,
        cpfUsuario: Number(INTEGRATION_DOCUMENT),
        service: 'messages',
        functionality: 'inclusaoLogJornada',
        filial: 1033,
        idProcesso: '2020202020',
        idServico: '4940404940',
        ipUsuario: '10.10.10.10',
        origem: origin,
        fluxo: 'OFERTA_SEGUROS',
        idProjeto: 1,
        idOrigem: originId,
        idFluxo: 15,
        idEvento: 8,
        observacao: `${type}|${user.email}|${user.phone ?? ''}`,
        cliCpf: user?.document,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
